import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { Overlay } from "@clinic/shared/components/MobileNav/Overlay/Overlay";
import { Sidebar as SidebarComponent } from "@clinic/shared/components/MobileNav/Sidebar/Sidebar";
import { SidebarToggle } from "@clinic/shared/components/MobileNav/SidebarToggle/SidebarToggle";
import { l } from "@clinic/shared/locales/i18n";
import { SvgFullscriptIcon } from "@shared/assets/logo";
import { Banners } from "@shared/components/Banners/Banners";
import { useBreakpoints } from "@shared/hooks/useBreakpoints/useBreakpoints";
import { Link } from "@shared/react-router-dom/react-router-dom";

import * as styles from "./MobileNav.styles";

interface Props {
  homeRoute: string;
  homeButton: any;
  toggleOpen: () => void;
  isOpen: boolean;
  children: ReactNode;
  logo?: ReactNode;
}

const MobileNav = ({
  homeRoute,
  homeButton,
  toggleOpen,
  isOpen,
  children,
  logo = <SvgFullscriptIcon css={styles.navLogo} />,
}: Props) => {
  const { tablet } = useBreakpoints();
  const { t } = useTranslation();

  if (tablet.greaterThan) {
    return null;
  }

  const getContent = () => {
    return (
      <>
        <Link css={styles.homeLink} to={homeRoute} aria-label={t(l.navigation.labels.home)}>
          {logo}
        </Link>
        <div css={styles.homeButton}>{homeButton}</div>
      </>
    );
  };

  return (
    <>
      <div css={styles.stickyMobileNav}>
        <div css={styles.stickyMobileNavContainer}>
          <div css={styles.mobileNavMain}>
            <div css={styles.sidebarToggleContainer}>
              <SidebarToggle
                aria-label={t(l.navigation.labels.openNavSidebar)}
                onClick={toggleOpen}
              />
              <SidebarComponent isOpen={isOpen} onClose={toggleOpen}>
                {children}
              </SidebarComponent>
            </div>
            {getContent()}
          </div>
          <Banners />
        </div>
      </div>
      <Overlay isOpen={isOpen} onClick={toggleOpen} />
    </>
  );
};

export { MobileNav };
